<template>
  <v-stepper-items>
    <v-stepper-content class="pa-0" step="3">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="7" xl="7">
          <v-container class="py-0">
            <v-card class="card py-5 my-3">
              <h3 class="text-center mb-3" translate>
                {{ $t(["REGISTRATION INFORMATION"]) }}
              </h3>

              <v-divider class="mx-3"></v-divider>

              <v-form ref="registrationForm">
                <v-row class="my-0 mx-3 mt-3">
                  <v-col cols="12" sm="6" class="py-0">
                    <!-- <div placeholder="{{ 'First Name' | translate }}"></div> -->
                    <v-text-field
                      id="firstName"
                      :label="$t(['First Name'])"
                      class="px-3 error-field"
                      v-model.trim="firstName"
                      :rules="rules.firstName"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" class="py-0">
                    <!-- <div placeholder="{{ 'Last Name' | translate }}"></div> -->
                    <v-text-field
                      id="lastName"
                      :label="$t(['Last Name'])"
                      class="px-3 error-field"
                      v-model.trim="lastName"
                      :rules="rules.lastName"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="my-0 mx-3">
                  <v-col cols="12" sm="6" class="py-0">
                    <!-- <div placeholder="{{ 'Address' | translate }}"></div> -->
                    <!-- <v-text-field
                      :label="$t(['Address_Label'])"
                      class="px-3 error-field"
                      v-model.trim="address"
                      :rules="rules.address"
                      @input="searchAddress($event)"
                    ></v-text-field> -->

                    <v-combobox
                      id="address"
                      :label="$t(['Address_Label'])"
                      class="px-3 error-field"
                      v-model="address"
                      :loading="isAddressLoading"
                      :search-input.sync="searchInput"
                      :rules="rules.address"
                      :items="filteredAddresses"
                      item-text="name"
                      item-value="placeId"
                      @change="populateFields($event)"
                    >
                      <template v-slot:selection="{ item }">
                        {{ item.mainText }}
                      </template>
                    </v-combobox>
                  </v-col>

                  <v-col cols="12" sm="6" class="py-0">
                    <!-- <div
                      placeholder="{{ 'App, Suite, ...' | translate }}"
                    ></div> -->
                    <v-text-field
                      id="address2"
                      :label="$t(['App, Suite, ...'])"
                      class="px-3"
                      v-model.trim="app_suite"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="my-0 mx-3">
                  <v-col cols="12" sm="6" class="py-0">
                    <!-- <div placeholder="{{ 'City/Town' | translate }}"></div> -->
                    <v-text-field
                      id="city"
                      :label="$t(['City/Town'])"
                      class="px-3 error-field"
                      v-model.trim="city"
                      :rules="rules.city"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" class="py-0">
                    <!-- <div placeholder="{{ 'Province' | translate }}"></div> -->
                    <v-select
                      id="province"
                      :label="$t(['Province_Label'])"
                      class="px-3 error-field"
                      auto-select-first
                      v-model="province"
                      :rules="rules.province"
                      :item-color="'primary'"
                      :items="
                        Object.keys(store.canadaProvinceOptions).map(
                          (province) => {
                            return $t(province);
                          }
                        )
                      "
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row class="my-0 mx-3">
                  <v-col cols="12" sm="6" class="py-0">
                    <!-- <div placeholder="{{ 'Postal Code' | translate }}"></div> -->
                    <v-text-field
                      id="postalCode"
                      :label="$t(['PostalCode_Label'])"
                      class="px-3 error-field"
                      v-model="postalCode"
                      v-mask="'A#A #A#'"
                      :rules="rules.postalCode"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" class="py-0">
                    <!-- <div placeholder="{{ 'Phone Number' | translate }}"></div> -->
                    <v-text-field
                      id="phoneNumber"
                      :label="$t(['PhoneNumber_Label'])"
                      class="px-3 error-field"
                      v-model="phoneNumber"
                      v-mask="'(###) ###-####'"
                      :rules="rules.phoneNumber"
                      autocomplete="form-phoneNumber"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="my-0 mx-6">
                  <!-- <div placeholder="{{ 'Email' | translate }}"></div> -->
                  <v-text-field
                    id="email"
                    :label="$t(['Email_Label'])"
                    class="px-3 error-field"
                    v-model.trim="email"
                    :rules="rules.email"
                  ></v-text-field>
                </v-row>

                <v-row class="my-0 mx-6 py-0">
                  <v-input hide-details>
                    <v-col cols="6" class="py-0">
                      <!-- <div placeholder="{{ 'If this form covers a family, please indicate # of people (0-9)' | translate }}"></div> -->
                      <p class="flex-wrap black--text pr-10">
                        {{
                          $t([
                            "If this form covers a family, please indicate # of people (0-9)",
                          ])
                        }}
                      </p>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        id="familyNumber"
                        label="#"
                        class="error-field"
                        v-model="familyNumber"
                        v-mask="'#'"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-input>
                </v-row>
              </v-form>

              <v-row class="my-0 mx-6" align="center" justify="center">
                <v-input hide-details>
                  <v-col cols="6" class="py-0">
                    <p class="flex-wrap black--text pr-10" translate>
                      {{
                        $t([
                          "I have participated in: (# of years) Terry Fox Run(s)",
                        ])
                      }}
                    </p>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      id="participationYears"
                      label="#"
                      class="error-field"
                      v-model="participationYears"
                      v-mask="'##'"
                      outlined
                      dense
                      hide-details
                      :error="participationYearsError"
                    ></v-text-field>
                    <p
                      v-show="participationYearsError"
                      class="error-font-size error--text"
                      translate
                    >
                      {{ $t(["42 is the maximum number of years"]) }}
                    </p>
                  </v-col>
                </v-input>
              </v-row>

              <v-row class="my-0 mx-8">
                <v-checkbox
                  id="volunteerCheckbox"
                  class="mb-6 my-0"
                  v-model="volunteerCheckbox"
                  hide-details
                >
                  <template v-slot:label>
                    <!-- <div placeholder="{{ 'Are you interested in volunteering with our Terry Fox Run NEXT YEAR?' | translate }}"></div> -->
                    <div>
                      {{
                        $t([
                          "Are you interested in volunteering with our Terry Fox Run NEXT YEAR",
                        ])
                      }}
                    </div>
                  </template>
                </v-checkbox>
              </v-row>

              <v-divider class="mx-3"></v-divider>

              <v-row class="mt-3">
                <v-col cols="6" align="center">
                  <v-btn class="btn-text" large @click="previousStep()">
                    {{ $t(["Back"]) }}
                  </v-btn>
                </v-col>

                <v-col cols="6" align="center">
                  <v-btn
                    class="btn-text"
                    color="primary"
                    large
                    @click="nextStep()"
                  >
                    {{ $t(["Next"]) }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-col>
      </v-row>
    </v-stepper-content>
  </v-stepper-items>
</template>

<script>
import { useFormDataStore } from "../../../store/formData.js";

import gmapsInit from "@/utils/gmaps.js";

export default {
  name: "S3_RegistrationInfo",
  data: () => {
    return {
      firstName: "",
      lastName: "",
      address: "",
      app_suite: "",
      city: "",
      province: "",
      postalCode: "",
      phoneNumber: "",
      email: "",
      familyNumber: null,
      participationYears: null,
      volunteerCheckbox: false,
      participationYearsError: false,
      rules: {
        firstName: [],
        lastName: [],
        address: [],
        city: [],
        postalCode: [],
        province: [],
        phoneNumber: [],
        email: [],
      },
      form: {
        cardNumber: null,
      },

      searchInput: null,
      isAddressLoading: false,
      autoCompleteService: null,
      geocoder: null,
      filteredAddresses: [],
    };
  },
  setup() {
    const store = useFormDataStore();

    return {
      store,
    };
  },
  props: {
    orderPhoneNumber: String,
  },
  async mounted() {
    let google = await gmapsInit();

    if (google) {
      this.autoCompleteService =
        new window.google.maps.places.AutocompleteService();
      this.geocoder = new window.google.maps.Geocoder();
    } else {
      console.error("Google Maps API error");
    }
  },
  watch: {
    "$i18n.locale"() {
      this.$refs.registrationForm.resetValidation();
    },
    orderPhoneNumber() {
      this.phoneNumber = this.orderPhoneNumber;
    },
    postalCode() {
      this.postalCode = this.postalCode.toUpperCase();
    },
    participationYears(value) {
      if (value <= 42) {
        this.participationYearsError = false;
      }
    },
    searchInput() {
      if (this.searchInput == null || this.searchInput == "") {
        this.filteredAddresses = [];
      } else {
        this.isAddressLoading = true;
        this.autoCompleteService.getPlacePredictions(
          {
            input: this.searchInput,
            componentRestrictions: { country: ["ca"] },
            types: ["address"],
          },
          this.addressSearchResults
        );
      }

      this.isAddressLoading = false;
    },
  },
  methods: {
    addressSearchResults(predictions, status) {
      // console.log(predictions);
      // console.log(status);

      if (status == "OK") {
        this.filteredAddresses = [];

        predictions.forEach((place) => {
          this.filteredAddresses.push({
            name: place.description,
            placeId: place.place_id,
            mainText: place.structured_formatting.main_text,
          });
        });
      }
    },
    populateFields(address) {
      if (address && address.placeId) {
        this.geocoder
          .geocode({
            placeId: address.placeId,
          })
          .then((result) => {
            result.results[0].address_components.forEach((component) => {
              if (component.types.includes("locality")) {
                this.city = component.long_name;
              } else if (
                component.types.includes("administrative_area_level_2") &&
                !component.types.includes("locality")
              ) {
                this.city = component.long_name;
              } else if (
                component.types.includes("administrative_area_level_1")
              ) {
                this.province = component.long_name;
              } else if (component.types.includes("postal_code")) {
                this.postalCode = component.long_name;
              }
            });

            this.$nextTick(() => {
              document.querySelector("#email").focus();
            });
          });
      } else {
        this.filteredAddresses = [];
      }
    },
    setFieldValidationRules() {
      this.rules.firstName = [(v) => !!v.trim() || this.$t(["Required"])];
      this.rules.lastName = [(v) => !!v.trim() || this.$t(["Required"])];
      this.rules.address = [(v) => !!v || this.$t(["Required"])];
      this.rules.city = [(v) => !!v.trim() || this.$t(["Required"])];
      this.rules.province = [(v) => !!v || this.$t(["Required"])];
      this.rules.postalCode = [
        (v) => !!v || this.$t(["Required"]),
        (v) =>
          (v || "").length >= 7 ||
          this.$gettext(this.$t(["Invalid postal code"])),
      ];
      this.rules.phoneNumber = [
        (v) => !!v || this.$t(["Required"]),
        (v) =>
          (v || "").length >= 14 ||
          this.$gettext(this.$t(["Invalid phone number"])),
      ];

      let emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      this.rules.email = [
        (v) => !!v.trim() || this.$t(["Required"]),
        (v) => emailRegex.test(v) || this.$gettext(this.$t(["Invalid e-mail"])),
      ];
    },
    async nextStep() {
      await this.setFieldValidationRules();

      if (this.participationYears > 42) {
        this.participationYearsError = true;
        return;
      }

      if (this.$refs.registrationForm.validate()) {
        this.store.setRegistrationInfoFormData({
          firstName: this.firstName.trim(),
          lastName: this.lastName.trim(),
          address:
            this.address instanceof Object
              ? this.address.mainText
              : this.address.trim(),
          address2: this.app_suite.trim(),
          city: this.city.trim(),
          province:
            this.$i18n.locale == "en"
              ? this.store.canadaProvinceOptions[this.province]
              : this.store.canadaProvinceOptionsFR[this.province],
          registrationPostalCode: this.postalCode,
          phone: this.phoneNumber,
          email: this.email.trim(),
          familyNumber:
            this.familyNumber != "" ? parseInt(this.familyNumber) : 0,
          participationYears:
            this.participationYears != ""
              ? parseInt(this.participationYears)
              : 0,
          volunteerCheckbox: this.volunteerCheckbox,
        });

        // console.log(this.store.registrationInfoFormData);

        this.$emit("nextStepFromThree");
      } else {
        // Scroll to first error
        this.$nextTick(() => {
          const el = this.$el.querySelector(
            ".v-messages.error--text:first-of-type"
          );
          this.$vuetify.goTo(-5, el);

          return;
        });
      }
    },
    previousStep() {
      this.$emit("previousStepFromThree");
    },
  },
};
</script>

<style lang="scss" scoped></style>
